import Button from '../ui/Button';

// Confirm dialog for a governed bulk edit: shows the dry-run summary of what a
// "set field = value across N rows" change will do, then applies it. The page
// runs the dry-run (so this stays presentational) and passes summary lines +
// the apply handler. Mirrors the existing import dry-run → Apply modals.
export default function BulkPreviewModal({ title, lines, error, applying, done, onApply, onClose }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} onClick={onClose} />
      <div style={{
        position: 'relative', width: 'min(520px, 94vw)', maxHeight: '84vh', overflow: 'auto',
        background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius)',
        padding: 20, display: 'flex', flexDirection: 'column', gap: 12,
      }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>{title}</div>

        {error && <div style={{ color: 'var(--danger)', fontSize: 13 }}>{error}</div>}

        {!error && !lines && !done && (
          <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Checking the change against the database…</div>
        )}

        {!error && lines && !done && (
          <>
            <div style={{ fontSize: 13, color: 'var(--text-body)', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {lines.map((l, i) => <div key={i}>{l}</div>)}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <Button size="sm" onClick={onClose}>Cancel</Button>
              <Button size="sm" variant="primary" disabled={applying} onClick={onApply}>
                {applying ? 'Applying…' : 'Apply'}
              </Button>
            </div>
          </>
        )}

        {done && (
          <>
            <div style={{ fontSize: 13, color: 'var(--text-body)' }}>{done}</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button size="sm" variant="primary" onClick={onClose}>Close</Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
